import { Authenticator } from 'infrastructure/security/authentication/authenticator';
import useAzureAuthenticator from 'infrastructure/security/authentication/azure/azureAuthenticator';
import useAuthenticationTokenRepository from 'infrastructure/security/authentication/tokenprovider/authenticationTokenRepository';
import { AuthenticationToken } from 'infrastructure/security/authentication/tokenprovider/authenticationToken.types';

interface AuthenticationService {
  isAuthenticated: () => Promise<boolean>;
  getCurrentAuthenticator: () => Promise<Nullable<Authenticator>>;
}

const useAuthenticationService = (): AuthenticationService => {
  const { getToken } = useAuthenticationTokenRepository();
  const azureAuthenticator = useAzureAuthenticator();

  const isAuthenticated = async (): Promise<boolean> => {
    const authToken: AuthenticationToken = await getToken();

    return !!authToken;
  };

  const getCurrentAuthenticator = async (): Promise<Nullable<Authenticator>> => {
    const isUserAuthenticated = await isAuthenticated();

    return isUserAuthenticated ? azureAuthenticator : null;
  };

  return {
    isAuthenticated,
    getCurrentAuthenticator,
  };
};

export default useAuthenticationService;
